import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import config from "../../config";

function ServiceList() {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const fetchServices = async () => {
    try {
      const response = await axios.get(
        `${config.BASE_URL}/api/admin/services`,
        { withCredentials: true }
      );
      if (response.data?.data) {
        setServices(response.data?.data);
      }
    } catch (err) {
      setError("Failed to fetch services");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchServices();
  }, []);

  return (
    <div className="dashboard">
      <div className="container">
        <h1 className="dash_title">Services</h1>
        <div className="main-section">
          <div className="projects">
            <div className="projects-inner">
              <header className="projects-header">
                <div className="title">
                  Total
                  <div className="count"> {services.length} Services</div>
                </div>
                <div className="project_search">
                  <form action="">
                    <input
                      type="text"
                      name="search"
                      placeholder="Search services"
                    />
                    <button type="submit" className="btn">
                      Search
                    </button>
                  </form>
                </div>
                <div className="add_project">
                  <Link to="/admin/add-service">Add Service</Link>
                </div>
              </header>

              <table className="projects-table">
                <thead>
                  <tr>
                    <th>Title</th>
                    <th>Subtitle</th>
                    <th className="text-right">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan="3">Loading...</td>
                    </tr>
                  ) : error ? (
                    <tr>
                      <td colSpan="3">{error}</td>
                    </tr>
                  ) : services.length > 0 ? (
                    services.map((service) => (
                      <tr key={service._id}>
                        <td>
                          <p>{service?.hero?.title || "-"}</p>
                        </td>
                        <td>
                          <p>{service?.hero?.subtitle || "-"}</p>
                        </td>
                        <td className="text-right">
                          <Link
                            to={`/admin/service/${service._id}`}
                            className="view_detail"
                          >
                            View Details
                          </Link>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="3">No services found.</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ServiceList;
